<template>
    <footer class="login-footer">
        <p>By continuing you agree to<br>
        Motom's <a href="#" @click="openProtalTerms">Terms of Use</a> and 
        <a href="#" @click="openPrivacy">Privacy Policy</a></p>
        <!-- <router-link :to="'/help'">Contact Support</router-link> -->
        <a :href="`mailto:${$store.state.mail_to_creator}?subject=${$store.state.user_data.merchant_account ? $store.state.user_data.merchant_account.merchant_display_name + ' - ' : ''}Support Request&body=Please%20describe%20your%20issue%20below%20in%20as%20much%20detail%20as%20possible%20(including%20what%20device%20you're%20using%20and%20screenshots,%20if%20necessary).%20A%20support%20team%20member%20will%20contact%20you%20within%201-2%20business%20days.`" target="_blank">Contact Support</a>
    </footer>
</template>

<script>
export default {
    name: 'login-footer',
    methods:{
        openPrivacy(){
            this.EventBus.emit('open-global-drawer', 'privacy-policy');
        },

        openProtalTerms(){
            this.EventBus.emit('open-global-drawer', 'terms-of-use');
        },
    }
}
</script>
<style lang="scss">
    .login-footer {
        text-align: center;
        font-size: 12px;
        color: var(--black-60);

        p {
            margin-bottom: 8px;
        }
    }
</style>

